import React, {useEffect, useState} from 'react'
import styles from './styles.module.sass'
import cn from 'classnames'

const Checkbox = ({ checked, onChange }) => {
  return (
    <>
      <input type="checkbox" checked={!!checked} onChange={onChange} />
      <span
        className={cn(styles.icon, {
          [styles.checked]: checked,
        })}
      >
        <div className={styles.check} />
      </span>
    </>
  )
}

const CheckboxForm = ({ text = 'Stanovi', smallText="", onCheck = () => {}, hp, initiallyChecked = false, isDifference }) => {
    const [isChecked, setIsChecked] = useState(initiallyChecked)

    useEffect(() => {
        setIsChecked(initiallyChecked);
    }, [initiallyChecked])

    const handleCheckboxChange = () => {
        const updatedValue = !isChecked
        setIsChecked(updatedValue);
        onCheck(updatedValue)
    }

  return (
    <div className={cn(styles.container, {
      [styles.diff]: isDifference,
    })}>
      <label className="d-flex align-items-center">
          <Checkbox
              checked={!hp ? isChecked : initiallyChecked}
              onChange={handleCheckboxChange}
          />
        <span className={styles.text}>{text}</span>
        <span className={styles.smallText}>{smallText}</span>
      </label>
    </div>
  )
}

export default CheckboxForm
